module.exports = __webpack_public_path__ + "img/yimei.aa03e5d1.jpg";